import {
  Component,
  EventEmitter,
  Input,
  inject,
  OnInit,
  Output, SimpleChanges, ContentChild, TemplateRef,
} from '@angular/core';
import { MakeCallService, CommonGeneralConfigService} from 'common-framework';
import {PageButtonItem} from "./page-buttons.interface";
import _, { isFunction, isNil } from 'lodash';

@Component({
  selector: 'page-buttons',
  templateUrl: './page-buttons.component.html',
  styleUrls: ['./page-buttons.component.scss']
})

export class PageButtonsComponent implements OnInit {
  @ContentChild('contentAboveButtons', { read: TemplateRef }) contentAboveButtons: TemplateRef<any>;

  @Input() hideBtnListOnDesktop = false;
  @Input() hideBtnListOnMobile = false;
  @Input() isBtnListDisabled = false;
  @Input() btnList: PageButtonItem[] = [];
  @Input() dataShimmer;
  @Input() lineBreakBtns;
  isShownDefaultEnv;


  @Output() onFunctionCalledEvent = new EventEmitter<{ functionName: string, item: object }>();

  protected makeCall: MakeCallService = inject(MakeCallService);
  protected generalConfigService: CommonGeneralConfigService = inject(CommonGeneralConfigService);


  constructor() {
    const isShownDefaultEnvConfig = this.generalConfigService.getConfig().pageButtonsConfig?.isShownDefaultTrue;
    this.isShownDefaultEnv = isShownDefaultEnvConfig !== undefined ? isShownDefaultEnvConfig : false;
  }

  ngOnInit() {
    if (this.dataShimmer === undefined) {
      this.makeCall.isLoading.subscribe((isLoading) => {
        this.dataShimmer = isLoading;
      });
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['btnList'] && !isNil(this.btnList)) {
      this.btnList.forEach(btnItem => {
        if (btnItem.isShown === undefined) {
          btnItem.isShown = this.isShownDefaultEnv ?? false;
        }
      });
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.setPageContentMargin();
    }, 0);
  }

  setPageContentMargin() {
    let responsiveButtons = document.getElementsByClassName("responsive-buttons-container");
    if(responsiveButtons.length){
      for (var i = 0; i < responsiveButtons.length; i++) {
          let responsiveButtonsContainerHeight = document.getElementsByClassName("responsive-buttons-container")[i] ? document.getElementsByClassName("responsive-buttons-container")[i].getBoundingClientRect().height : 0;
          if(document.getElementsByClassName("page-content")[0]) {
            // @ts-ignore
            document.getElementsByClassName("page-content")[0].style.marginBottom = responsiveButtonsContainerHeight + 'px';
          }
      }
    }
  }

  btnFunctionCalled(name, data) {
    this.onFunctionCalledEvent.emit({
      functionName: name,
      item: data
    });
  }

  shouldDisableButton(item: PageButtonItem): boolean {
    if (item.hasOwnProperty('isDisabled')) {
      if (isFunction(item.isDisabled)) {
        return item.isDisabled();
      } else {
        return item.isDisabled;
      }
    } else {
      return false;
    }
  }

  shouldShowButton(item: PageButtonItem): boolean {
    if (item.hasOwnProperty('isShown')) {
      if (isFunction(item.isShown)) {
        return item.isShown();
      } else {
        return item.isShown;
      }
    } else {
      return false;
    }
  }

}
